/**
 * @author ydoni
 * @description password 입력 시 bubble
 */
import styled from "styled-components";
import { COLORS } from "styles/colors";
import { calcRem } from "styles/theme";
import InfoBubble from "./InfoBubble";
import { FLEX } from "styles/flex";
import { checkPasswordNumberRegEx, checkPasswordRegEx } from "utils/regEx";
import WARNING_ICON from "assets/icons/warning_red.svg";
import ONLINE_ICON from "assets/icons/online.svg";
import { Text } from "components/atoms/text/Text";

export interface PasswordRule {
  label: string;
  condition: (password: string) => boolean;
}

type OptionBubbleProps = {
  password: string;
  rules?: PasswordRule[];
  title?: string;
};

const initialRules = [
  {
    label: "8 or more characters",
    condition: (password: string) => password.length < 8,
  },
  {
    label: "Upper & lowercase letters",
    condition: (password: string) => !checkPasswordRegEx(password),
  },
  {
    label: "At least one number and Special Character",
    condition: (password: string) => !checkPasswordNumberRegEx(password),
  },
];

function PasswordBubble({
  password,
  title = "Password must contain:",
  rules = initialRules,
}: OptionBubbleProps): JSX.Element {
  return (
    <InfoBubble>
      <Text fontSize={15} bold color={COLORS.WHITE}>
        {title}
      </Text>
      <ul>
        {rules.map((rule) => (
          <PasswordText key={rule.label}>
            <img
              src={rule.condition(password) ? WARNING_ICON : ONLINE_ICON}
              alt=""
            />
            {rule.label}
          </PasswordText>
        ))}
      </ul>
    </InfoBubble>
  );
}

export const PasswordText = styled.li`
  ${FLEX.FlexCenterCenter};
  gap: 8px;
  font-size: ${calcRem(15)};

  > img {
    width: 15px;
    height: 15px;
  }
`;

export default PasswordBubble;
